/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools-battery-charging': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.875 6.875h-.625V6.25C16.25 5.56 15.69 5 15 5h-2.5v1.25H15v1.875h1.875v3.75H15v1.875h-3.125V15H15c.69 0 1.25-.56 1.25-1.25v-.625h.625c.69 0 1.25-.56 1.25-1.25v-3.75c0-.69-.56-1.25-1.25-1.25zm-10 6.875H3.75v-7.5H7.5V5H3.75c-.69 0-1.25.56-1.25 1.25v7.5c0 .69.56 1.25 1.25 1.25h3.125v-1.25zm2.381.988l-1.012-.726 2.418-3.387H5.856l4.281-5.388.976.776-2.67 3.362h4.645l-3.832 5.363z"/>'
  }
})
